/**
 * @file
 * Eloqua webform javascript behaviors.
 */

/* global Eloqua gated content */

if (typeof drupalSettings === undefined) {
  let drupalSettings = {};
}

(function (Drupal, cookies, once) {
  "use strict";

  /**
   * Attach and detach Eloqua gated content JS.
   */
  Drupal.behaviors.eloquaGatedContent = {
    attach: function (context) {
      function getQueryVariable(query, variable) {
        if (query.indexOf("?") !== -1) {
          query = query.substring(query.indexOf("?") + 1, query.length);
        }
        if (query.indexOf("#") !== -1) {
          query = query.substring(0, query.indexOf("#"));
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] === variable) {
            return pair[1];
          }
        }
        return false;
      }

      if(context.querySelector('.gated-download a') !== null || context.querySelector('.webinar-gate') !== null) {
        var file, target, cid;
        cid = (context.querySelector('.gated-download') !== null) ? context.querySelector('.gated-download').getAttribute('data-cid') : (context.querySelector('.webinar-gate') !== null) ? context.querySelector('.webinar-gate').getAttribute('data-cid') : '';

        context.querySelector('input[name="cid"]').value = (getQueryVariable(window.location.href, "cid") !== false) ? getQueryVariable(window.location.href, "cid") : (cid !== '') ? cid : '';
        context.querySelector('input[name="utm_campaign"]').value = (getQueryVariable(window.location.href, "utm_campaign") !== false) ? getQueryVariable(window.location.href, "utm_campaign") : '';
        context.querySelector('input[name="utm_source"]').value = (getQueryVariable(window.location.href, "utm_source") !== false) ? getQueryVariable(window.location.href, "utm_source") : '';
        context.querySelector('input[name="utm_medium"]').value = (getQueryVariable(window.location.href, "utm_medium") !== false) ? getQueryVariable(window.location.href, "utm_medium") : '';
        context.querySelector('input[name="utm_term"]').value = (getQueryVariable(window.location.href, "utm_term") !== false) ? getQueryVariable(window.location.href, "utm_term") : '';
        context.querySelector('input[name="utm_content"]').value = (getQueryVariable(window.location.href, "utm_content") !== false) ? getQueryVariable(window.location.href, "utm_content") : '';
        context.querySelector('input[name="source_url"]').value = window.location.origin + window.location.pathname;
        

        if(context.querySelector('.gated-download a') !== null) {
          file = context.querySelector('.gated-download a');
          // We will use the hidden target field to handle redirect.
          target = context.querySelector('input[name="target"]');

          if (file === null || target === null) {
            return;
          }
          target.value = file.href;
        }
        else {
          file = context.querySelector('.webinar-gate');
          // We will use the hidden target field to handle redirect.
          target = context.querySelector('input[name="target"]');

          if (file === null || target === null) {
            return;
          }

          var decorateStarter = window.location.href.indexOf("?") === -1 ? "?" : "&";
          target.value = window.location.origin + window.location.pathname + '?uuid=' + file.getAttribute('data-uuid') + '#video';

          var uuidCheck = getQueryVariable(window.location.href, 'uuid');
          var uuidCookieName = window.location.pathname.replace('/webinar/', 'uuid-');
          var uuidCookie = Cookies.get(uuidCookieName);

          var webinarCookieName = window.location.pathname.replace('/webinar/', 'webinar-');
          var webinarCookie = Cookies.get(webinarCookieName);

          if(webinarCookie === undefined) {
            if(uuidCookie === undefined) {
              Cookies.set(uuidCookieName, file.getAttribute('data-uuid'), { path: window.location.pathname, domain: window.location.host, secure: true });
            }
            else {
              if(uuidCheck === false && uuidCheck !== uuidCookie) {
                Cookies.remove(uuidCookieName, { path: window.location.pathname, domain: window.location.host });
                Cookies.set(uuidCookieName, file.getAttribute('data-uuid'), { path: window.location.pathname, domain: window.location.host, secure: true });
              }
              else if(uuidCheck !== false && uuidCheck === uuidCookie) {
                Cookies.set(webinarCookieName, uuidCheck, { expires: 7, path: window.location.pathname, domain: window.location.host, secure: true });
                file.style.display = 'none';
                context.querySelector('.video-container').style.display = 'block';
              }
            }
          }
          else {
            file.style.display = 'none';
            context.querySelector('.video-container').style.display = 'block';
          }
        }

        file.addEventListener("click", function(event) {
          event.preventDefault();
          Drupal.behaviors.eloquaGatedContent.openDialog(context);
        }, false);
      }
    },
    openDialog: function (context) {

      var body = context.body;
      var html = context.documentElement;
      var max = Math.min(
        1000,
        Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight),
        Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth)
      ) - 64;

      var file, title, settings;

      if(context.querySelector('.gated-download a') !== null || context.querySelector('.webinar-gate') !== null) {
        if(context.querySelector('.gated-download a') !== null) {
          file = context.querySelector('.gated-download a');
          title = 'Download Form';
          if (file.text != undefined) {
            title = file.text;
          }

          settings = {
            // beforeClose: function (event, ui) {},
            close: function(event, ui) {
              let form = context.querySelector('div[role="dialog"] > form.webform-submission-form');
            },
            title: 'Please share your contact information',
            width: max,
            modal: true
          };
        }
        else {
          file = context.querySelector('.webinar-gate');
          title = 'Webinar Form';
          if (file.text != undefined) {
            title = file.text;
          }

          settings = {
            // beforeClose: function (event, ui) {},
            close: function(event, ui) {
              let form = context.querySelector('div[role="dialog"] > form.webform-submission-form');
            },
            title: 'Please share your contact information',
            width: max,
            modal: true
          };
        }
      }

      Drupal.dialog(context.querySelector('form.webform-submission-form'), settings).showModal();
    }
  }
})(Drupal, window.Cookies, once);
